/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import styled from "styled-components";

import {
	columnWrapper,
	rowWrapper
} from "../../styled/styled-extends";
import {
	setFont
} from "../../styled/styled-mixins";

// EXPORT

export const ErrorWrapper = styled.p`
	color: #F04438;//D92D20;//; // use colors... set in props
`;

export const LabelWrapper = styled.label`
`;

export const ComponentWrapper = styled.div`
	width: 100%;
	text-align: left;

	> div {
		flex: 1;
		${columnWrapper}

		> p {
			padding-top: 8px; // !!! gap
		}
	}
`;

	/*
	${(props) => {
		const {
			colors,
			text
		} = props.theme;

		let baseStyle;
		let gap;

		switch(props.direction) {
			case "horizontal":
				baseStyle = `
					align-items: center;
					justify-content: space-between;
					${rowWrapper}
				`;
				gap = "48px";
			break;
			case "vertical":
				baseStyle = `
					${columnWrapper}
				`;
				gap = "8px";
			break;
		}

		return `
			gap: ${gap};
			${baseStyle}
			${setFont(
				text.font.inter,
				text.sizeMapping.small.fontSize,
				text.weightMapping.regular,
				text.sizeMapping.small.lineHeight,
				colors.gray[600]
			)}

			${ErrorWrapper} {
				color: ${colors.error[600]};
			}

			${LabelWrapper} {
				color: ${colors.gray[700]};
				font-weight: ${text.weightMapping.semibold};
			}
		`;
	}}
	*/